import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../../components/Header";
import PodcastBanner from "../../assets/audio/podcast-banner.png";
import { GetAllPodcastCategoriesApi } from "../../services/Api";

const PodcastHome = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await GetAllPodcastCategoriesApi();
      if (response && response.data) {
        setCategories(response.data);
      }
    };
    fetchCategories();
  }, []);

  const handleCardClick = (category) => {
    navigate("/podcast", {
      state: {
        categoryId: category.categoryId,
        categoryTitle: category.categoryTitle,
        categoryImageUrl: category.categoryImageUrl,
      },
    });
  };

  return (
    <div className="page-container relative bg-white min-h-screen">
      {/* Header */}
      <Header />

      {/* Banner */}
      <div className="w-[40%] mx-auto mt-6 mb-10">
        <img
          src={PodcastBanner}
          alt="Podcast Banner"
          className="w-full h-auto object-cover rounded-lg shadow-md"
        />
      </div>

      {/* Podcast Categories */}
      <div className="w-[40%] mx-auto mb-12">
        <h2 className="text-2xl font-semibold mb-4 text-center">Podcast Categories</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {categories.map((category) => (
            <div
              key={category.categoryId}
              className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer transition-transform hover:scale-105 flex flex-col justify-between"
              onClick={() => handleCardClick(category)}
              style={{ height: "180px" }}
            >
              <div className="h-[100px] flex items-center justify-center p-2">
                <img
                  src={category.categoryImageUrl}
                  alt={category.categoryTitle}
                  className="max-h-full w-full object-contain"
                />
              </div>
              <div className="p-2 text-center">
                <h3 className="text-base font-semibold text-gray-800 truncate">
                  {category.categoryTitle}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PodcastHome;
